module.exports = __webpack_public_path__ + "img/logo.4bdf0983.png";